import React from 'react';
import { SPECIFIC_SUGGESTION_REGEX } from 'core/constants/regex';
import { CandidateProfileChip } from 'modules/candidate-profile/components/CandidateProfileChip';

/**
 * Parses user message body and replaces <specific_suggestion> tags with chips.
 * Simpler version without UUID/candidate profile parsing.
 */
export const parseUserMessageWithChips = (
  messageBody: string
): React.ReactNode[] => {
  const result: React.ReactNode[] = [];
  const matches = Array.from(messageBody.matchAll(SPECIFIC_SUGGESTION_REGEX));
  let lastIndex = 0;
  let chipKey = 0;

  matches.forEach((match, matchIndex) => {
    // Add text before the match
    if (match.index !== undefined && match.index > lastIndex) {
      const textContent = messageBody.substring(lastIndex, match.index);
      result.push(
        <React.Fragment key={`text-before-${matchIndex}`}>
          {textContent}
        </React.Fragment>
      );
    }

    const suggestionContent = match[1];

    result.push(
      <CandidateProfileChip
        key={`chip-${chipKey++}`}
        label={suggestionContent}
        size="small"
      />
    );

    if (match.index !== undefined) {
      lastIndex = match.index + match[0].length;
    }
  });

  // Add remaining text
  if (lastIndex < messageBody.length) {
    const textContent = messageBody.substring(lastIndex);
    result.push(<React.Fragment key="text-end">{textContent}</React.Fragment>);
  }

  // If no matches found, return original message
  return result.length > 0 ? result : [messageBody];
};
